import { IconType } from '@shared/utils/icons';
import { Component, Input } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'shared-ui-buttons-button-copy-to-clipboard',
    templateUrl: './button-copy-to-clipboard.component.html',
    styleUrls: ['./button-copy-to-clipboard.component.css'],
    standalone: false
})
export class ButtonCopyToClipboardComponent extends ButtonComponent {
  @Input() textToCopy? = '';

  isCopied = false;

  constructor() {
    super();
  }

  override buttonClicked(): void {
    if (this.textToCopy) {
      navigator.clipboard.writeText(this.textToCopy);
      this.isCopied = true;
    }
  }

  setIcon(): IconType {
    return this.isCopied ? IconType.Check : IconType.Copy;
  }

  setButtonText(): string {
    return this.isCopied ? 'Copied' : 'Copy to clipboard';
  }
}
